import { VsmSymbolId } from './vsmSymbols';

export interface VsmIconMarkup {
  viewBox: string;
  /** Inner SVG markup from DMN_VSM_RACI visual reference (monochrome). */
  markup: string;
}

/** Palette / preview glyphs — Lucidchart-aligned VSM library (PRD §5). */
export const VSM_ICON_MARKUP: Record<VsmSymbolId, VsmIconMarkup> = {
  customerSupplier: {

    viewBox: '13.5 18.5 103.0 83.0',

    markup: `<path d="M 15 100 L 15 45 L 40 20 L 40 45 L 65 20 L 65 45 L 90 20 L 90 45 L 115 20 L 115 45 L 115 100 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  dedicatedProcessFlow: {

    viewBox: '6.5 6.5 147.0 67.0',

    markup: `<rect x="8" y="8" width="144" height="64" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  sharedProcess: {

    viewBox: '6.5 6.5 147.0 67.0',

    markup: `<rect x="8" y="8" width="144" height="64" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="45" y1="8" x2="45" y2="72" stroke="#1A202C" stroke-width="1"/>
              <line x1="80" y1="8" x2="80" y2="72" stroke="#1A202C" stroke-width="1"/>
              <line x1="115" y1="8" x2="115" y2="72" stroke="#1A202C" stroke-width="1"/>`,

  },
  dataBox: {

    viewBox: '6.5 3.5 147.0 93.0',

    markup: `<rect x="8" y="5" width="144" height="36" fill="white" stroke="#1A202C" stroke-width="2"/>
              <rect x="8" y="45" width="144" height="50" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="80" y1="45" x2="80" y2="95" stroke="#1A202C" stroke-width="1"/>
              <line x1="8" y1="70" x2="152" y2="70" stroke="#1A202C" stroke-width="1"/>
              <text x="14" y="62" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">C/T: 90s</text>
              <text x="86" y="62" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">C/O: 15m</text>
              <text x="14" y="87" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">Up: 95%</text>
              <text x="86" y="87" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">Batch: 24</text>`,

  },
  workcell: {

    viewBox: '13.5 13.5 113.0 63.0',

    markup: `<path d="M 15 15 L 125 15 L 125 75 L 15 75 L 15 30 L 110 30 L 110 60 L 30 60 L 30 30 L 15 30 Z" fill="white" stroke="#1A202C" stroke-width="2" fill-rule="evenodd"/>`,

  },
  inventory: {

    viewBox: '8.5 13.5 83 63',

    markup: `<polygon points="50,15 90,75 10,75" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="50" y="63" font-size="18" font-weight="600" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">I</text>`,

  },
  shipments: {

    viewBox: '8.5 6.5 143.0 57.0',

    markup: `<defs>
                <pattern id="vsm-shipments-ship-stripes" patternUnits="userSpaceOnUse" width="8" height="8">
                  <line x1="0" y1="0" x2="0" y2="8" stroke="#1A202C" stroke-width="1.5"/>
                </pattern>
              </defs>
              <path d="M 10 20 L 118 20 L 118 8 L 150 35 L 118 62 L 118 50 L 10 50 Z" fill="url(#vsm-shipments-ship-stripes)" stroke="#1A202C" stroke-width="2"/>`,

  },
  pushArrow: {

    viewBox: '8.5 6.5 143.0 47.0',

    markup: `<defs>
                <pattern id="vsm-pushArrow-push-stripes" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
                  <line x1="0" y1="0" x2="0" y2="6" stroke="#1A202C" stroke-width="2"/>
                </pattern>
              </defs>
              <path d="M 10 20 L 120 20 L 120 8 L 150 30 L 120 52 L 120 40 L 10 40 Z" fill="url(#vsm-pushArrow-push-stripes)" stroke="#1A202C" stroke-width="2"/>`,

  },
  supermarket: {

    viewBox: '18.5 13.5 103.0 63.0',

    markup: `<line x1="20" y1="15" x2="20" y2="75" stroke="#1A202C" stroke-width="2"/>
              <line x1="20" y1="15" x2="120" y2="15" stroke="#1A202C" stroke-width="2"/>
              <line x1="20" y1="35" x2="120" y2="35" stroke="#1A202C" stroke-width="2"/>
              <line x1="20" y1="55" x2="120" y2="55" stroke="#1A202C" stroke-width="2"/>
              <line x1="20" y1="75" x2="120" y2="75" stroke="#1A202C" stroke-width="2"/>`,

  },
  materialPull: {

    viewBox: '13.5 11.5 95.0 55.0',

    markup: `<path d="M 15 65 Q 15 20 60 20 L 95 20" fill="none" stroke="#1A202C" stroke-width="2"/>
              <polygon points="95,13 107,20 95,27" fill="#1A202C"/>`,

  },
  fifoLane: {

    viewBox: '8.5 18.5 138.0 23.0',

    markup: `<path d="M 10 20 L 130 20 L 145 30 L 130 40 L 10 40 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="70" y="34" font-size="12" font-weight="700" fill="#1A202C" text-anchor="middle" font-family="system-ui, sans-serif">FIFO</text>`,

  },
  safetyStock: {

    viewBox: '13.5 18.5 73 43',

    markup: `<rect x="15" y="20" width="70" height="40" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="50" y="48" font-size="16" font-weight="700" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">SS</text>`,

  },
  externalShipment: {

    viewBox: '8.5 23.5 123.0 51.0',

    markup: `<rect x="10" y="25" width="76" height="35" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 86 35 L 116 35 L 130 50 L 130 60 L 86 60 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="30" cy="65" r="8" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="30" cy="65" r="3" fill="#1A202C"/>
              <circle cx="112" cy="65" r="8" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="112" cy="65" r="3" fill="#1A202C"/>`,

  },
  productionControl: {

    viewBox: '8.5 13.5 143.0 53.0',

    markup: `<rect x="10" y="15" width="140" height="50" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="80" y="38" font-size="11" font-weight="600" fill="#1A202C" text-anchor="middle" font-family="system-ui, sans-serif">Production</text>
              <text x="80" y="54" font-size="11" font-weight="600" fill="#1A202C" text-anchor="middle" font-family="system-ui, sans-serif">Control</text>`,

  },
  manualInfo: {

    viewBox: '8.9 13.9 144.2 12.2',

    markup: `<line x1="10" y1="20" x2="140" y2="20" stroke="#1A202C" stroke-width="1.2"/>
              <polygon points="140,15 152,20 140,25" fill="none" stroke="#1A202C" stroke-width="1.2"/>`,

  },
  electronicInfo: {

    viewBox: '8.8 13.8 148.8 32.5',

    markup: `<polyline points="10,30 35,30 50,15 65,45 80,15 95,45 110,30 148,30" fill="none" stroke="#1A202C" stroke-width="1.5"/>
              <polygon points="148,25 156,30 148,35" fill="#1A202C"/>`,

  },
  productionKanban: {

    viewBox: '13.5 13.5 93 53',

    markup: `<rect x="15" y="15" width="90" height="50" fill="white" stroke="#1A202C" stroke-width="2" stroke-dasharray="4,3"/>
              <text x="60" y="45" font-size="12" font-weight="600" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">Kanban</text>`,

  },
  withdrawalKanban: {

    viewBox: '13.5 13.5 93.0 53.0',

    markup: `<rect x="15" y="15" width="90" height="50" fill="white" stroke="#1A202C" stroke-width="2"/>
              <polyline points="30,40 55,40 55,32 78,40 55,48 55,40" fill="#1A202C" stroke="#1A202C" stroke-width="1.5"/>`,

  },
  signalKanban: {

    viewBox: '18.5 13.5 68.0 53.0',

    markup: `<polygon points="20,15 85,40 20,65" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  kanbanPost: {

    viewBox: '13.5 13.5 53.0 83.0',

    markup: `<rect x="15" y="15" width="50" height="35" fill="white" stroke="#1A202C" stroke-width="2"/>
              <rect x="37" y="50" width="6" height="45" fill="#1A202C"/>
              <line x1="15" y1="95" x2="65" y2="95" stroke="#1A202C" stroke-width="2"/>`,

  },
  sequencedPull: {

    viewBox: '8.5 18.5 113.0 43.0',

    markup: `<rect x="10" y="20" width="70" height="40" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="45" y="45" font-size="12" font-weight="700" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">SEQ</text>
              <polyline points="85,40 105,40 105,32 120,40 105,48 105,40" fill="#1A202C"/>`,

  },
  loadLevelling: {

    viewBox: '8.5 13.5 143.0 53.0',

    markup: `<rect x="10" y="15" width="140" height="50" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="45" y1="15" x2="45" y2="65" stroke="#1A202C" stroke-width="1"/>
              <line x1="80" y1="15" x2="80" y2="65" stroke="#1A202C" stroke-width="1"/>
              <line x1="115" y1="15" x2="115" y2="65" stroke="#1A202C" stroke-width="1"/>
              <line x1="10" y1="32" x2="150" y2="32" stroke="#1A202C" stroke-width="1"/>
              <line x1="10" y1="48" x2="150" y2="48" stroke="#1A202C" stroke-width="1"/>`,

  },
  mrpErp: {

    viewBox: '13.5 18.5 93 43',

    markup: `<rect x="15" y="20" width="90" height="40" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="60" y="46" font-size="15" font-weight="700" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">MRP</text>`,

  },
  goSee: {

    viewBox: '19.5 14.5 81.0 31.0',

    markup: `<circle cx="35" cy="30" r="14" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="85" cy="30" r="14" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="49" y1="30" x2="71" y2="30" stroke="#1A202C" stroke-width="2"/>`,

  },
  verbalInformation: {

    viewBox: '8.8 10.8 144.8 15.8',

    markup: `<path d="M 10 20 Q 20 12 30 20 T 50 20 T 70 20 T 90 20 T 110 20 T 130 20 T 140 20" fill="none" stroke="#1A202C" stroke-width="1.5"/>
              <polygon points="140,15 152,20 140,25" fill="#1A202C"/>`,

  },
  kaizenBurst: {

    viewBox: '14.5 6.5 71.0 81.0',

    markup: `<polygon points="50,8 58,28 78,22 66,40 84,48 66,54 78,72 58,66 50,86 42,66 22,72 34,54 16,48 34,40 22,22 42,28" fill="white" stroke="#1A202C" stroke-width="2" stroke-linejoin="round"/>`,

  },
  operator: {

    viewBox: '16.5 14.5 47.0 71.0',

    markup: `<circle cx="40" cy="28" r="12" fill="none" stroke="#1A202C" stroke-width="2"/>
              <path d="M 18 78 Q 18 50 40 50 Q 62 50 62 78 L 62 84 L 18 84 Z" fill="none" stroke="#1A202C" stroke-width="2"/>`,

  },
  otherInformation: {

    viewBox: '13.5 13.5 93.0 53.0',

    markup: `<rect x="15" y="15" width="90" height="50" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="25" y1="28" x2="95" y2="28" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="36" x2="82" y2="36" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="44" x2="95" y2="44" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="52" x2="70" y2="52" stroke="#1A202C" stroke-width="1"/>`,

  },
  timeline: {

    viewBox: '8.8 1.0 362.5 81.0',

    markup: `<polyline points="10,50 40,50 40,20 90,20 90,50 140,50 140,20 190,20 190,50 240,50 240,20 290,20 290,50 340,50 340,20 370,20" fill="none" stroke="#1A202C" stroke-width="1.5"/>
              <text x="20" y="66" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">3m</text>
              <text x="55" y="15" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">2d</text>
              <text x="110" y="66" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">5m</text>
              <text x="155" y="15" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">1d</text>
              <text x="210" y="66" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">4m</text>
              <text x="255" y="15" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">3d</text>
              <text x="310" y="66" font-size="9" fill="#1A202C" font-family="system-ui, sans-serif">6m</text>
              <text x="200" y="78" font-size="8" font-weight="600" fill="#4A5568" text-anchor="middle" font-family="system-ui, sans-serif">short = VA · long = NVA</text>`,

  },
  transportationRail: {

    viewBox: '13.5 13.5 118.0 46.0',

    markup: `<rect x="15" y="20" width="80" height="25" fill="white" stroke="#1A202C" stroke-width="2"/>
              <rect x="22" y="26" width="12" height="13" fill="none" stroke="#1A202C" stroke-width="1"/>
              <rect x="40" y="26" width="12" height="13" fill="none" stroke="#1A202C" stroke-width="1"/>
              <rect x="58" y="26" width="12" height="13" fill="none" stroke="#1A202C" stroke-width="1"/>
              <rect x="76" y="26" width="12" height="13" fill="none" stroke="#1A202C" stroke-width="1"/>
              <polygon points="95,15 120,15 130,32 130,45 95,45" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="30" cy="52" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="50" cy="52" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="75" cy="52" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="115" cy="52" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  transportationAir: {

    viewBox: '13.5 18.5 113.0 48.0',

    markup: `<path d="M 15 40 L 55 35 L 70 20 L 78 20 L 72 35 L 105 35 L 120 25 L 125 30 L 115 42 L 125 55 L 120 60 L 105 50 L 72 50 L 78 65 L 70 65 L 55 50 L 15 45 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  transportationBoat: {

    viewBox: '13.9 13.5 117.2 58.0',

    markup: `<path d="M 20 50 L 120 50 L 110 70 L 30 70 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="70" y1="15" x2="70" y2="50" stroke="#1A202C" stroke-width="2"/>
              <path d="M 70 20 L 100 45 L 70 45 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 15 60 Q 30 65 45 60 Q 60 55 75 60 Q 90 65 105 60 Q 120 55 130 60" fill="none" stroke="#1A202C" stroke-width="1.2"/>`,

  },
  forklift: {

    viewBox: '28.5 18.5 91.0 54.0',

    markup: `<rect x="30" y="35" width="45" height="25" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 50 35 L 45 20 L 70 20 L 70 35" fill="white" stroke="#1A202C" stroke-width="2"/>
              <line x1="75" y1="40" x2="115" y2="40" stroke="#1A202C" stroke-width="2"/>
              <line x1="75" y1="50" x2="115" y2="50" stroke="#1A202C" stroke-width="2"/>
              <line x1="115" y1="35" x2="115" y2="60" stroke="#1A202C" stroke-width="2"/>
              <line x1="118" y1="35" x2="118" y2="60" stroke="#1A202C" stroke-width="2"/>
              <circle cx="45" cy="65" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="70" cy="65" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  expedited: {

    viewBox: '13.5 13.0 83.5 44.0',

    markup: `<polygon points="15,35 50,15 50,55" fill="#1A202C"/>
              <polygon points="55,35 90,15 90,55" fill="#1A202C"/>
              <line x1="95" y1="15" x2="95" y2="55" stroke="#1A202C" stroke-width="3"/>`,

  },
  milkRun: {

    viewBox: '13.5 7.5 119.0 62.0',

    markup: `<rect x="15" y="30" width="55" height="25" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 70 35 L 95 35 L 105 47 L 105 55 L 70 55 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="30" cy="62" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="90" cy="62" r="6" fill="white" stroke="#1A202C" stroke-width="2"/>
              <circle cx="115" cy="22" r="3" fill="#1A202C"/>
              <circle cx="128" cy="12" r="3" fill="#1A202C"/>
              <line x1="107" y1="30" x2="115" y2="22" stroke="#1A202C" stroke-width="1" stroke-dasharray="2,2"/>
              <line x1="118" y1="20" x2="128" y2="12" stroke="#1A202C" stroke-width="1" stroke-dasharray="2,2"/>`,

  },
  warehouse: {

    viewBox: '13.5 13.5 113.0 68.0',

    markup: `<path d="M 15 40 L 70 15 L 125 40 L 125 80 L 15 80 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <rect x="60" y="55" width="20" height="25" fill="white" stroke="#1A202C" stroke-width="1.5"/>`,

  },
  crossDock: {

    viewBox: '8.5 12.5 123.0 55.0',

    markup: `<path d="M 15 22 L 110 22 L 110 14 L 130 27 L 110 40 L 110 32 L 15 32 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 125 48 L 30 48 L 30 40 L 10 53 L 30 66 L 30 58 L 125 58 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  orders: {

    viewBox: '13.5 8.5 53.0 83.0',

    markup: `<path d="M 15 10 L 50 10 L 65 25 L 65 90 L 15 90 Z" fill="white" stroke="#1A202C" stroke-width="2"/>
              <path d="M 50 10 L 50 25 L 65 25" fill="none" stroke="#1A202C" stroke-width="2"/>
              <line x1="25" y1="45" x2="55" y2="45" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="55" x2="55" y2="55" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="65" x2="55" y2="65" stroke="#1A202C" stroke-width="1"/>
              <line x1="25" y1="75" x2="45" y2="75" stroke="#1A202C" stroke-width="1"/>`,

  },
  phone: {

    viewBox: '10.5 13.5 71.0 74.0',

    markup: `<path d="M 20 25 Q 20 15 30 15 L 38 15 Q 44 15 46 23 L 48 32 Q 50 40 42 42 L 38 44 Q 45 58 55 65 L 57 63 Q 62 55 68 62 L 74 68 Q 80 74 72 80 L 68 82 Q 55 86 40 76 Q 22 62 16 45 Q 12 34 20 25 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  batchedKanban: {

    viewBox: '12.5 4.5 94.0 50.0',

    markup: `<rect x="30" y="18" width="75" height="35" fill="white" stroke="#1A202C" stroke-width="2" stroke-dasharray="4,3"/>
              <rect x="22" y="12" width="75" height="35" fill="white" stroke="#1A202C" stroke-width="2" stroke-dasharray="4,3"/>
              <rect x="14" y="6" width="75" height="35" fill="white" stroke="#1A202C" stroke-width="2" stroke-dasharray="4,3"/>`,

  },
  controlCenter: {

    viewBox: '18.5 13.5 83.0 63.0',

    markup: `<rect x="20" y="15" width="80" height="55" fill="white" stroke="#1A202C" stroke-width="2"/>
              <rect x="28" y="22" width="64" height="38" fill="white" stroke="#1A202C" stroke-width="1.5"/>
              <line x1="45" y1="75" x2="75" y2="75" stroke="#1A202C" stroke-width="2"/>
              <line x1="60" y1="70" x2="60" y2="75" stroke="#1A202C" stroke-width="2"/>`,

  },
  qualityProblem: {

    viewBox: '8.5 8.5 73 73',

    markup: `<polygon points="45,10 80,45 45,80 10,45" fill="white" stroke="#1A202C" stroke-width="2"/>
              <text x="45" y="55" font-size="26" font-weight="700" text-anchor="middle" fill="#1A202C" font-family="system-ui, sans-serif">!</text>`,

  },
  solutionImprovement: {

    viewBox: '18.5 8.5 117.0 67.0',

    markup: `<path d="M 35 60 Q 20 60 20 45 Q 20 32 32 30 Q 34 18 48 17 Q 60 10 72 20 Q 88 15 98 26 Q 118 25 122 40 Q 132 44 128 58 Q 134 72 118 74 L 42 74 Q 28 74 28 66 Q 22 62 35 60 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
};
